import {safeLocalStorage} from './safeLocalStorage.js';

const

    getCookie = name => document.cookie.replace(new RegExp("(?:(?:^|.*;\\s*)" + name + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1"),

    setCookie = (name, value, maxAge ) => {
    let secureFlag = document.location.protocol === 'https:' ? ';secure' : '';
    document.cookie = typeof maxAge !== 'undefined'?
    `${name}=${encodeURIComponent(value)};path=/;domain=.${window.location.hostname};max-age=${maxAge}${secureFlag}` : `${name}=${encodeURIComponent(value)};path=/${secureFlag}`
    },

    hideCookiesBanner = () => {
        const cookiesBanner = document.querySelector( '.cookies-warning-banner' );
        if ( cookiesBanner ) {
            if ( safeLocalStorage.getItem( 'hide-cookies-banner' ) ) {
                cookiesBanner.remove();
                return;
            }
            const hideBtn = cookiesBanner.querySelector( '.js-hide-cookies-btn' );
            if ( hideBtn ) {
                hideBtn.addEventListener( 'click', () => {
                    safeLocalStorage.setItem( 'hide-cookies-banner', 'true' );
                    cookiesBanner.remove();
                } );
            }
        }
    };

export {
    getCookie,
    setCookie,
    hideCookiesBanner
};